import BaseApi from './BaseApi'

class PendingApprovalAdviserProfilesApi extends BaseApi {

  get pendingApprovalAdviserProfilesUrl () {
    return 'adviserProfilesPendingApproval'
  }

  submitForApproval (adviserId) {
    return this.postJson(`${this.pendingApprovalAdviserProfilesUrl}/${adviserId}`)
  }

  getPendingApprovalProfile (adviserId) {
    return this.getJson(`${this.pendingApprovalAdviserProfilesUrl}/${adviserId}`)
  }

  getPendingApprovalProfiles (searchTerm, currentPage, pageSize, filter, orderBy, sortAscending) {
    searchTerm = searchTerm || ''
    currentPage = currentPage || 1
    var parameters = `searchTerm=${searchTerm}&currentPage=${currentPage}&pageSize=${pageSize}&filter=${filter}&orderBy=${orderBy}&sortAscending=${sortAscending}`
    return this.getJson(`${this.pendingApprovalAdviserProfilesUrl}?${parameters}`)
  }

  updatePendingApprovalAdviserProfile (adviserId, profile) {
    return this.putJson(`${this.pendingApprovalAdviserProfilesUrl}/${adviserId}`, profile)
  }

  updateLanguagePreferences (adviserId, profile) {
    return this.putJson(`${this.pendingApprovalAdviserProfilesUrl}/${adviserId}/languages`, profile)
  }

  updateClientTypes (adviserId, profile) {
    return this.putJson(`${this.pendingApprovalAdviserProfilesUrl}/${adviserId}/clientTypes`, profile)
  }

  updateAreasOfSpecialisation (adviserId, profile) {
    return this.putJson(`${this.pendingApprovalAdviserProfilesUrl}/${adviserId}/specialisations`, profile)
  }

  updateConflictDeclarations (adviserId, profile) {
    return this.putJson(`${this.pendingApprovalAdviserProfilesUrl}/${adviserId}/conflictDeclarations`, profile)
  }

  updateEducation (adviserId, profile) {
    return this.putJson(`${this.pendingApprovalAdviserProfilesUrl}/${adviserId}/qualifications`, profile)
  }

  updateContactNumbers (adviserId, profile) {
    return this.putJson(`${this.pendingApprovalAdviserProfilesUrl}/${adviserId}/contactNumbers`, profile)
  }

  updatePublicContactEmailAddress (adviserId, profile) {
    return this.putJson(`${this.pendingApprovalAdviserProfilesUrl}/${adviserId}/publicContactEmailAddress`, profile)
  }

  updateProfilePicture (adviserId, profile) {
    return this.putJson(`${this.pendingApprovalAdviserProfilesUrl}/${adviserId}/profilePicture`, profile)
  }

  updateCompanyLogo (adviserId, profile) {
    return this.putJson(`${this.pendingApprovalAdviserProfilesUrl}/${adviserId}/companyLogo`, profile)
  }

  updateInvestmentMinimums (adviserId, profile) {
    return this.putJson(`${this.pendingApprovalAdviserProfilesUrl}/${adviserId}/investmentMinimums`, profile)
  }

  updateEducationQualifications (adviserId, profile) {
    return this.putJson(`${this.pendingApprovalAdviserProfilesUrl}/${adviserId}/qualifications`, profile)
  }

  updateWorkExperiences (adviserId, profile) {
    return this.putJson(`${this.pendingApprovalAdviserProfilesUrl}/${adviserId}/workExperiences`, profile)
  }

  rejectProfile (adviserId) {
    return this.deleteJson(`${this.pendingApprovalAdviserProfilesUrl}/${adviserId}`)
  }
}
export default PendingApprovalAdviserProfilesApi
